import React from 'react'
import { Container, Typography } from '@toptal/picasso'
import { Facebook, Twitter, Linkedin } from '@toptal/picasso/Icon'
import styled from 'styled-components'
import { getShareUrl } from '../../utils'
import texts from '../../texts.json'

const ShareLink = styled.a`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid white;
  border-radius: 100%;
  margin: 0 5px;
`

const openSharePopup = (e: React.MouseEvent) => {
  e.preventDefault()

  const url = e.currentTarget.getAttribute('href') as string
  const popup = window.open(url, '', 'width=600,height=600') as Window

  popup.addEventListener('blur', () => {
    popup.close()
  })
}

const Social: React.FunctionComponent = () => {
  const ICON_SIZE = 1.2
  const ICON_COLOR = 'white'

  return (
    <Container>
      <Typography
        variant='h3'
        inline={true}
        style={{ color: 'white', marginRight: 15 }}
      >
        Share:
      </Typography>
      <ShareLink
        onClick={openSharePopup}
        href={getShareUrl('LinkedIn', {
          url: texts.social.url,
          title: texts.social.title
        })}
      >
        <Linkedin size={ICON_SIZE} color={ICON_COLOR} />
      </ShareLink>
      <ShareLink
        onClick={openSharePopup}
        href={getShareUrl('Twitter', {
          url: texts.social.url,
          title: texts.social.title
        })}
      >
        <Twitter size={ICON_SIZE} color={ICON_COLOR} />
      </ShareLink>
      <ShareLink
        onClick={openSharePopup}
        href={getShareUrl('Facebook', {
          url: texts.social.url
        })}
      >
        <Facebook size={ICON_SIZE} color={ICON_COLOR} />
      </ShareLink>
    </Container>
  )
}

export default Social
